import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";

import { Icon } from "@/components/Icon";

export interface ChildToggleButtonProps {
  /**
   * Children to display when the button is clicked. If null, the node does not support children at all so no button will
   * be rendered. If an empty array is provided, a disabled button will be rendered.
   */
  children: unknown[] | null;

  showChildren: boolean;
  toggleShowChildren: () => void;
}

export const ChildToggleButton: React.FC<ChildToggleButtonProps> = ({ children, showChildren, toggleShowChildren }) => {
  // Render nothing for items that do not support children
  if (!children) return null;

  // Render an un-clickable button for items that support children but do not have one
  if (!children.length) {
    return (
      <OverlayTrigger overlay={<Tooltip>No children found</Tooltip>}>
        <Button variant="link" className="p-0">
          <Icon icon="x-square" className="text-muted" />
        </Button>
      </OverlayTrigger>
    );
  }

  // Otherwise, render a toggle button
  return (
    <OverlayTrigger overlay={<Tooltip>{showChildren ? "Hide Children" : "Show Children"}</Tooltip>}>
      <Button variant="link" className="p-0 lh-1" onClick={children.length ? toggleShowChildren : undefined}>
        <Icon icon={showChildren ? "dash-square" : "plus-square-fill"} />
      </Button>
    </OverlayTrigger>
  );
};
